module.exports = __webpack_public_path__ + "img/20190724152957494.d38764ad.png";